/**
 * The pollutant fields of the AQ forecast payload, and the guard every AQ
 * reader applies before trusting a number. Moved from mobile's
 * `screens/common/AirQuality/utils.ts` (FE #331).
 */

/** Per-pollutant sub-index fields added to the AQ forecast API by backend !543. */
export const AQ_SUB_INDEX_KEYS = {
  AQ_PM2P5: 'AQ_PM2P5_AQI',
  AQ_PM10: 'AQ_PM10_AQI',
  AQ_O3: 'AQ_O3_AQI',
  AQ_NO2: 'AQ_NO2_AQI',
  AQ_SO2: 'AQ_SO2_AQI',
  AQ_CO: 'AQ_CO_AQI',
} as const;

export const isFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

/**
 * `AQ_DOMINANT` carries the pollutant NAME that `compute_us_epa_aqi` reports —
 * `PM2.5`, `O3`, … — not the measure key. Production returns `"AQ_DOMINANT":
 * "O3"`; this map was keyed by `AQ_O3`, so it resolved to undefined for every
 * hour and the dominant pollutant has never been displayed. The measure keys are
 * kept as aliases so a provider that ever sends them still resolves.
 */
export const AQ_DOMINANT_LABELS: Record<string, string> = {
  'PM2.5': 'PM2.5',
  PM10: 'PM10',
  O3: 'O₃',
  NO2: 'NO₂',
  SO2: 'SO₂',
  CO: 'CO',
  AQ_PM2P5: 'PM2.5',
  AQ_PM10: 'PM10',
  AQ_O3: 'O₃',
  AQ_NO2: 'NO₂',
  AQ_SO2: 'SO₂',
  AQ_CO: 'CO',
};

export const getAqDominantLabel = (
  dominant: string | undefined | null,
): string | undefined => {
  if (!dominant) {
    return undefined;
  }
  return AQ_DOMINANT_LABELS[dominant];
};
